import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { createWeb3Modal, defaultWagmiConfig } from '@web3modal/wagmi/react';
import { WagmiConfig } from 'wagmi';
import { mainnet, goerli } from 'wagmi/chains';

import './styles/style.scss';
import Home from './pages/Home';
import Width from './components/Width';
import Header from './components/Header';
import Footer from './components/Footer';
import Register from './pages/Register';
import Confirm from './pages/Confirm';
import Success from './pages/Success';
import Fail from './pages/Fail';

const projectId = process.env.REACT_APP_WALLET_CONNECT_PROJECT_ID as string;
const metadata = {
  name: 'ARTIVIST ART SCANNER',
  description: 'ARTIVIST ART SCANNER',
  url: process.env.REACT_APP_URL,
  icons: ['/assets/logo_apply-square.svg'],
};
const chains = [mainnet, goerli];
const wagmiConfig = defaultWagmiConfig({ chains, projectId, metadata });

createWeb3Modal({ wagmiConfig, projectId, chains });

function App() {
  return (
    <WagmiConfig config={wagmiConfig}>
      <Width>
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/home' element={<Home />} />
            <Route path='/register' element={<Register />} />
            <Route path='/confirm' element={<Confirm />} />
            <Route path='/success' element={<Success />} />
            <Route path='/fail' element={<Fail />} />
          </Routes>
        </BrowserRouter>
      </Width>
    </WagmiConfig>
  );
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
